<ng-container *ngIf="!hideHeader">
  <ng-container *ngIf="!isFinal; else final">
    <mat-card-header>
      <mat-card-title>Parties currently leading in districts</mat-card-title>
      <mat-card-subtitle>
        Votes for the House of Assembly are still being counted. The candidates leading in each district
        may change as more results become available
      </mat-card-subtitle>
    </mat-card-header>
  </ng-container>
  <ng-template #final>
    <mat-card-header>
      <mat-card-title>Seats won</mat-card-title>
    </mat-card-header>
  </ng-template>
</ng-container>
<mat-card-content>
  <div class="graph">
    <table class="card-container">
      <tr>
        <td>

        </td>
        <td>

        </td>
        <td>
          <div #tooltip21="matTooltip" [matTooltip]="hemicycleTooltips[21]" matTooltipClass="mat-toolTip" (click)="tooltip21.show()" class="dot" [style.background-color]="hemicycleDots[21]"></div>
        </td>
        <td>
          <div #tooltip22="matTooltip" [matTooltip]="hemicycleTooltips[22]" matTooltipClass="mat-toolTip" (click)="tooltip22.show()" class="dot" [style.background-color]="hemicycleDots[22]"></div>
        </td>
        <td>
          <div #tooltip23="matTooltip" [matTooltip]="hemicycleTooltips[23]" matTooltipClass="mat-toolTip" (click)="tooltip23.show()" class="dot" [style.background-color]="hemicycleDots[23]"></div>
        </td>
        <td>
          <div #tooltip26="matTooltip" [matTooltip]="hemicycleTooltips[26]" matTooltipClass="mat-toolTip" (click)="tooltip26.show()" class="dot" [style.background-color]="hemicycleDots[26]"></div>
        </td>
        <td>
          <div #tooltip27="matTooltip" [matTooltip]="hemicycleTooltips[27]" matTooltipClass="mat-toolTip" (click)="tooltip27.show()" class="dot" [style.background-color]="hemicycleDots[27]"></div>
        </td>
        <td>

        </td>
        <td>

        </td>
      </tr>
      <tr>
        <td>

        </td>
        <td>
          <div #tooltip18="matTooltip" [matTooltip]="hemicycleTooltips[18]" matTooltipClass="mat-toolTip" (click)="tooltip18.show()" class="dot" [style.background-color]="hemicycleDots[18]"></div>
        </td>
        <td>
          <div #tooltip19="matTooltip" [matTooltip]="hemicycleTooltips[19]" matTooltipClass="mat-toolTip" (click)="tooltip19.show()" class="dot" [style.background-color]="hemicycleDots[19]"></div>
        </td>
        <td>
          <div #tooltip20="matTooltip" [matTooltip]="hemicycleTooltips[20]" matTooltipClass="mat-toolTip" (click)="tooltip20.show()" class="dot" [style.background-color]="hemicycleDots[20]"></div>
        </td>
        <td>
          <div #tooltip24="matTooltip" [matTooltip]="hemicycleTooltips[24]" matTooltipClass="mat-toolTip" (click)="tooltip24.show()" class="dot" [style.background-color]="hemicycleDots[24]"></div>
        </td>
        <td>
          <div #tooltip28="matTooltip" [matTooltip]="hemicycleTooltips[28]" matTooltipClass="mat-toolTip" (click)="tooltip28.show()" class="dot" [style.background-color]="hemicycleDots[28]"></div>
        </td>
        <td>
          <div #tooltip29="matTooltip" [matTooltip]="hemicycleTooltips[29]" matTooltipClass="mat-toolTip" (click)="tooltip29.show()" class="dot" [style.background-color]="hemicycleDots[29]"></div>
        </td>
        <td>
          <div #tooltip30="matTooltip" [matTooltip]="hemicycleTooltips[30]" matTooltipClass="mat-toolTip" (click)="tooltip30.show()" class="dot" [style.background-color]="hemicycleDots[30]"></div>
        </td>
        <td>

        </td>
      </tr>
      <tr>
        <td>
          <div #tooltip17="matTooltip" [matTooltip]="hemicycleTooltips[17]" matTooltipClass="mat-toolTip" (click)="tooltip17.show()" class="dot" [style.background-color]="hemicycleDots[17]"></div>
        </td>
        <td>
          <div #tooltip16="matTooltip" [matTooltip]="hemicycleTooltips[16]" matTooltipClass="mat-toolTip" (click)="tooltip16.show()" class="dot" [style.background-color]="hemicycleDots[16]"></div>
        </td>
        <td>
          <div #tooltip15="matTooltip" [matTooltip]="hemicycleTooltips[15]" matTooltipClass="mat-toolTip" (click)="tooltip15.show()" class="dot" [style.background-color]="hemicycleDots[15]"></div>
        </td>
        <td>
          <div #tooltip14="matTooltip" [matTooltip]="hemicycleTooltips[14]" matTooltipClass="mat-toolTip" (click)="tooltip14.show()" class="dot" [style.background-color]="hemicycleDots[14]"></div>
        </td>
        <td>
          <div #tooltip25="matTooltip" [matTooltip]="hemicycleTooltips[25]" matTooltipClass="mat-toolTip" (click)="tooltip25.show()" class="dot" [style.background-color]="hemicycleDots[25]"></div>
        </td>
        <td>
          <div #tooltip34="matTooltip" [matTooltip]="hemicycleTooltips[34]" matTooltipClass="mat-toolTip" (click)="tooltip34.show()" class="dot" [style.background-color]="hemicycleDots[34]"></div>
        </td>
        <td>
          <div #tooltip33="matTooltip" [matTooltip]="hemicycleTooltips[33]" matTooltipClass="mat-toolTip" (click)="tooltip33.show()" class="dot" [style.background-color]="hemicycleDots[33]"></div>
        </td>
        <td>
          <div #tooltip32="matTooltip" [matTooltip]="hemicycleTooltips[32]" matTooltipClass="mat-toolTip" (click)="tooltip32.show()" class="dot" [style.background-color]="hemicycleDots[32]"></div>
        </td>
        <td>
          <div #tooltip31="matTooltip" [matTooltip]="hemicycleTooltips[31]" matTooltipClass="mat-toolTip" (click)="tooltip31.show()" class="dot" [style.background-color]="hemicycleDots[31]"></div>
        </td>
      </tr>
      <tr>
        <td>
          <div #tooltip13="matTooltip" [matTooltip]="hemicycleTooltips[13]" matTooltipClass="mat-toolTip" (click)="tooltip13.show()" class="dot" [style.background-color]="hemicycleDots[13]"></div>
        </td>
        <td>
          <div #tooltip12="matTooltip" [matTooltip]="hemicycleTooltips[12]" matTooltipClass="mat-toolTip" (click)="tooltip12.show()" class="dot" [style.background-color]="hemicycleDots[12]"></div>
        </td>
        <td>
          <div #tooltip11="matTooltip" [matTooltip]="hemicycleTooltips[11]" matTooltipClass="mat-toolTip" (click)="tooltip11.show()" class="dot" [style.background-color]="hemicycleDots[11]"></div>
        </td>
        <td>
          <div #tooltip10="matTooltip" [matTooltip]="hemicycleTooltips[10]" matTooltipClass="mat-toolTip" (click)="tooltip10.show()" class="dot" [style.background-color]="hemicycleDots[10]"></div>
        </td>
        <td>

        </td>
        <td>
          <div #tooltip38="matTooltip" [matTooltip]="hemicycleTooltips[38]" matTooltipClass="mat-toolTip" (click)="tooltip38.show()" class="dot" [style.background-color]="hemicycleDots[38]"></div>
        </td>
        <td>
          <div #tooltip37="matTooltip" [matTooltip]="hemicycleTooltips[37]" matTooltipClass="mat-toolTip" (click)="tooltip37.show()" class="dot" [style.background-color]="hemicycleDots[37]"></div>
        </td>
        <td>
          <div #tooltip36="matTooltip" [matTooltip]="hemicycleTooltips[36]" matTooltipClass="mat-toolTip" (click)="tooltip36.show()" class="dot" [style.background-color]="hemicycleDots[36]"></div>
        </td>
        <td>
          <div #tooltip35="matTooltip" [matTooltip]="hemicycleTooltips[35]" matTooltipClass="mat-toolTip" (click)="tooltip35.show()" class="dot" [style.background-color]="hemicycleDots[35]"></div>
        </td>
      </tr>
      <tr>
        <td>
          <div #tooltip9="matTooltip" [matTooltip]="hemicycleTooltips[9]" matTooltipClass="mat-toolTip" (click)="tooltip9.show()" class="dot" [style.background-color]="hemicycleDots[9]"></div>
        </td>
        <td>
          <div #tooltip8="matTooltip" [matTooltip]="hemicycleTooltips[8]" matTooltipClass="mat-toolTip" (click)="tooltip8.show()" class="dot" [style.background-color]="hemicycleDots[8]"></div>
        </td>
        <td>
          <div #tooltip7="matTooltip" [matTooltip]="hemicycleTooltips[7]" matTooltipClass="mat-toolTip" (click)="tooltip7.show()" class="dot" [style.background-color]="hemicycleDots[7]"></div>
        </td>
        <td colspan="3" align="center" class="info">

        </td>
        <td>
          <div #tooltip41="matTooltip" [matTooltip]="hemicycleTooltips[41]" matTooltipClass="mat-toolTip" (click)="tooltip41.show()" class="dot" [style.background-color]="hemicycleDots[41]"></div>
        </td>
        <td>
          <div #tooltip40="matTooltip" [matTooltip]="hemicycleTooltips[40]" matTooltipClass="mat-toolTip" (click)="tooltip40.show()" class="dot" [style.background-color]="hemicycleDots[40]"></div>
        </td>
        <td>
          <div #tooltip39="matTooltip" [matTooltip]="hemicycleTooltips[39]" matTooltipClass="mat-toolTip" (click)="tooltip39.show()" class="dot" [style.background-color]="hemicycleDots[39]"></div>
        </td>
      </tr>
      <tr>
        <td>
          <div #tooltip6="matTooltip" [matTooltip]="hemicycleTooltips[6]" matTooltipClass="mat-toolTip" (click)="tooltip6.show()" class="dot" [style.background-color]="hemicycleDots[6]"></div>
        </td>
        <td>
          <div #tooltip5="matTooltip" [matTooltip]="hemicycleTooltips[5]" matTooltipClass="mat-toolTip" (click)="tooltip5.show()" class="dot" [style.background-color]="hemicycleDots[5]"></div>
        </td>
        <td>
          <div #tooltip4="matTooltip" [matTooltip]="hemicycleTooltips[4]" matTooltipClass="mat-toolTip" (click)="tooltip4.show()" class="dot" [style.background-color]="hemicycleDots[4]"></div>
        </td>

        <td colspan="3" align="center" class="info">

        </td>
        <td>
          <div #tooltip44="matTooltip" [matTooltip]="hemicycleTooltips[44]" matTooltipClass="mat-toolTip" (click)="tooltip44.show()" class="dot" [style.background-color]="hemicycleDots[44]"></div>
        </td>
        <td>
          <div #tooltip43="matTooltip" [matTooltip]="hemicycleTooltips[43]" matTooltipClass="mat-toolTip" (click)="tooltip43.show()" class="dot" [style.background-color]="hemicycleDots[43]"></div>
        </td>
        <td>
          <div #tooltip42="matTooltip" [matTooltip]="hemicycleTooltips[42]" matTooltipClass="mat-toolTip" (click)="tooltip42.show()" class="dot" [style.background-color]="hemicycleDots[42]"></div>
        </td>
      </tr>
      <tr>
        <td>
          <div #tooltip3="matTooltip" [matTooltip]="hemicycleTooltips[3]" matTooltipClass="mat-toolTip" (click)="tooltip3.show()" class="dot" [style.background-color]="hemicycleDots[3]"></div>
        </td>
        <td>
          <div #tooltip2="matTooltip" [matTooltip]="hemicycleTooltips[2]" matTooltipClass="mat-toolTip" (click)="tooltip2.show()" class="dot" [style.background-color]="hemicycleDots[2]"></div>
        </td>
        <td>
          <div #tooltip1="matTooltip" [matTooltip]="hemicycleTooltips[1]" matTooltipClass="mat-toolTip" (click)="tooltip1.show()" class="dot" [style.background-color]="hemicycleDots[1]"></div>
        </td>
        <td colspan="3" align="center" class="info">

        </td>

        <td>
          <div #tooltip47="matTooltip" [matTooltip]="hemicycleTooltips[47]" matTooltipClass="mat-toolTip" (click)="tooltip47.show()" class="dot" [style.background-color]="hemicycleDots[47]"></div>
        </td>
        <td>
          <div #tooltip46="matTooltip" [matTooltip]="hemicycleTooltips[46]" matTooltipClass="mat-toolTip" (click)="tooltip46.show()" class="dot" [style.background-color]="hemicycleDots[46]"></div>
        </td>
        <td>
          <div #tooltip45="matTooltip" [matTooltip]="hemicycleTooltips[45]" matTooltipClass="mat-toolTip" (click)="tooltip45.show()" class="dot" [style.background-color]="hemicycleDots[45]"></div>
        </td>
      </tr>
    </table>
    <div style="margin-top: 13px" class="card-container">
        47 seats total,  24 seats needed for majority
    </div>
  </div>
</mat-card-content>
